import Vue from 'vue'
import VueRouter from 'vue-router'

import { commonRouters } from './myrouter/common'
// import { lscommonRouters } from './myrouter/lscommon'
// import { jdcommonRouters } from './myrouter/jdcommon'
// import { jdcommonRouters2 } from './myrouter/jdcommon2'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
//web路由
const routes = commonRouters
// const routes = jdcommonRouters2
//二维码路由
// const routes = lscommonRouters
// console.log('routesCy:', routesCy)
// eslint-disable-next-line no-new
const router = new VueRouter({
  mode: 'history',
  //   base: process.env.BASE_URL,
  //   base: '/jsc/', //机电打包需要
  routes,
  // routesCy,
  //   scrollBehavior(to, from, savedPosition) {
  // console.log('to:', to)
  // console.log('from:', from)
  // console.log('savedPosition:', savedPosition)
  // console.log('to.name:', to.name)
  // if (to.name == 'inforegist-index') {
  //   console.log('inforegist-index??')
  //   return savedPosition
  // }
  //   },
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // 判断是否有标题
    document.title = to.meta.title
  }
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})

export default router
